// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"654":"component---src-pages-example-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"654":"88d3a04f758e1e77aa07","678":"a2cad02bd38dc57ab328","883":"d9a2feb710306e06b26e"}[chunkId] + ".js";
};